module.exports = __webpack_public_path__ + "static/img/bg.7ed6757.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature/bg.jpg
// module id = KwTY
// module chunks = 7